import React, { useEffect, useState, CSSProperties } from "react";
import {
  createMuiTheme,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { Typography, Button } from "@material-ui/core";
import AddToListModal from "./addToListModal";
import { TOGGLE_GROWING_LIST_POPUP } from "../../Redux/actions";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { AnyMxRecord } from "dns";
import { SetOrganisationDetails } from "../../Pages/Roles/Admin/Organisation/Create/OrganisationDetails/OrganisationDetailsActions";

// const theme = createMuiTheme({
//   overrides: {
//     MuiInputLabel: {
//       outlined: {
//         transform: "translate(14px, 12.5px) scale(1)",
//       },
//     },
//     MuiOutlinedInput: {
//       root: {
//         "&&& $input": {
//           padding: "2px",
//         },
//       },
//     },
//     MuiChip: {
//       root: {
//         borderRadius: "0px",
//         height: "27px",
//       },
//       deleteIcon: {
//         color: "black",
//         height: "15px",
//       },
//       deleteIconOutlinedColorPrimary: {
//         variant: "outlined",
//       },
//     },
//   },
// });
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      // color: 'green',
      // '& label.Mui-focused': {
      //     color: 'green',
      // },
      // '& .MuiInput-underline:after': {
      //     borderBottomColor: 'green',
      // },
      // '& .MuiOutlinedInput-root': {
      //     '& fieldset': {
      //         borderColor: 'red',
      //     },
      //     '&:hover fieldset': {
      //         borderColor: 'yellow',
      //     },
      //     '&.Mui-focused fieldset': {
      //         borderColor: 'green',
      //     },
      // },
    },
    formControl: {
      width: "100%",
    },
    whiteColor: {
      color: "red",
    },
  })
);
function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

function SelectSpecific(props) {
  // console.log(props)
  const classes = useStyles();
  // const [selectedValue, setSelectedValue] = React.useState("");
  const [showModal, setShowModal] = useState(false);
  const [postData, setPostData] = useState({});
  const dispatch = useDispatch();
  // const [inputValue, setInputValue] = React.useState("");
  // const [val, setValue] = React.useState("");
  // const [options, setOptions] = React.useState([]);

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  const {
    // label,
    type,
    name,
    placeholder,
    required,
    selectOptions,
    defaultValue,
    disabled,
    readOnly,
    error,
    infoIcon,
    infoMessage,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    multiline,
    index,
    handleChange,
    hoverText,
    isDynamicField,
    dropDown,
    field_name,
    moduleName,
    isChild,
  } = props.componentObject;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3); // For demo purposes.

      if (active) {
        setOptions(selectOptions);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (selectOptions?.length) {
      if (field_name && dropDown) {
        setOptions([{ value: "+Add New" }, ...selectOptions]);
      }
    }
  }, [selectOptions?.length]);

  const handleAddNew = (event) => {
    event.preventDefault();
    setPostData({ drop_down: dropDown, field_name: field_name });
    setShowModal(true);
    dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
  };

  const handleAddNewValue = React.useCallback(
    (value, id) => {
      isChild
        ? handleChange(id, index, "", isDynamicField)
        : handleChange(id, index);
    },
    [isChild, handleChange]
  );

  return (
    <FormControl
      size='small'
      variant={"outlined"}
      // style={{ color: '#a9a9a9' }}
      // className={clsx(classes.formControl, classes.root)}
      // error={helperText ? true : false}
    >
      <Autocomplete
        id='asynchronous-demo'
        freeSolo
        forcePopupIcon={true}
        value={
          selectOptions
            ? selectOptions[
                selectOptions?.findIndex((item) => item.id == value)
              ] || []
            : []
        }
        isOptionEqualToValue={(option, data) => option.id === data.id}
        getOptionLabel={(option) => option.value}
        disabled={disabled}
        // options={options}
        options={field_name && dropDown ? options : selectOptions}
        loading={loading}
        onChange={(e, newValue) => {
          if (newValue?.value === "+Add New") {
            handleAddNew(e);
            setShowModal(true);
            // let targetIndex =newValue && newValue.findIndex((each) => each.value === "newValue");
            // newValue.splice(targetIndex-1, 1);
            console.log("targetIndex", newValue, typeof newValue);
          } else {
            isChild
              ? handleChange(newValue?.id, index, "", isDynamicField)
              : handleChange(newValue?.id, index);
          }
        }}
        renderInput={(params) => (
          <React.Fragment>
            <TextField
              {...params}
              autoFocus={autoFocus}
              // InputProps={{ style: { fontSize: "16px", fontFamily: "Open Sans" } }}
              InputLabelProps={{
                style: { fontSize: "16px", fontFamily: "Open Sans" },
              }}
              required={required ? required : false}
              placeholder={placeholder}
              error={helperText ? true : false}
              variant='outlined'
            />
            <span
              style={{
                color: "#f44336",
                fontSize: "0.75rem",
                marginRight: "14px",
              }}
            >
              {" "}
              {helperText}
            </span>
          </React.Fragment>
        )}
      />
      {showModal && (
        <AddToListModal
          setShowModal={setShowModal}
          postData={postData}
          type={moduleName}
          handleAddNewValue={handleAddNewValue}
        />
      )}
    </FormControl>
  );
}

export default SelectSpecific;
